/**
 * Numbers only. The callers compare against 500, and `'404' < 500` coerces to
 * true, so a string status would be read as a real one and silence the error.
 *
 * Both keys because hand-built error objects in this repo carry either. An
 * ofetch rejection defines both over the same response, and h3's `createError`
 * folds `status` into `statusCode`, so neither library needs the second read.
 */
export function httpStatusOf(error: unknown): number | undefined {
  if (!error || typeof error !== 'object') return undefined
  const { statusCode, status } = error as { statusCode?: unknown; status?: unknown }
  if (typeof statusCode === 'number') return statusCode
  return typeof status === 'number' ? status : undefined
}

export function isUncaughtNotFound(isUncaught: boolean, args: readonly unknown[]): boolean {
  return isUncaught && httpStatusOf(args[1]) === 404
}
